module.exports = __webpack_public_path__ + "static/media/sensor-smoke.c39e2e28.svg";